import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api/gungho'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: false,
    user: false,
    cart: false,
    order: false,
    products: [],
    states: [],
    countries: [],
    customers: [],
    agree: false
  },

  getters: {
    loggedIn: state => {
      return state.token !== false
    },

    user: state => {
      return state.user
    },

    products: state => {
      return state.products
    },

    cart: state => {
      return state.cart
    },

    shippingAddress: state => {
      return state.order.shipping_address
    },

    billingAddress: state => {
      return state.order.billing_address
    },

    isAdmin: state => {
      return state.user.admin
    },

    features: state => {
      return state.user.features
    },

    states: state => {
      return state.states
    },

    countries: state => {
      return state.countries
    },

    customers: state => {
      return state.customers
    },

    agree: state => {
      return state.agree
    }
  },

  mutations: {
    saveToken (state, token) {
      state.token = token
    },

    saveUser (state, user) {
      state.user = user
    },

    saveCart (state, cart) {
      state.cart = cart
    },

    saveShipping (state, shipping) {
      state.cart.shipping_method = shipping[0]
      state.cart.total_shipping = shipping[1]
    },

    saveStates (state, states) {
      state.states = states
    },

    saveCountries (state, countries) {
      state.countries = countries
    },

    saveCustomers (state, customers) {
      state.customers = customers
    },

    saveProducts (state, products) {
      state.products = products
    },

    agree (state, tf) {
      state.agree = tf
    }
  },

  actions: {
    loadProducts ({ commit }) {
      if (this.products && this.products.length > 0) return

      api.products().then(data => {
        console.log('Load Products')
        commit('saveProducts', data.products)
      }).catch(error => {
        console.log(error)
      })
    },

    loadStates ({ commit }) {
      if (this.states && this.states.length > 0) return

      api.states().then(data => {
        console.log('Load States')
        commit('saveStates', data.states)
      }).catch(error => {
        console.log(error)
      })
    },

    loadCountries ({ commit }) {
      if (this.countries && this.countries.length > 0) return

      api.countries().then(data => {
        console.log('Load Countries')
        commit('saveCountries', data.countries)
      }).catch(error => {
        console.log(error)
      })
    },

    loadCustomers ({ commit }) {
      if (this.customers && this.customers.length > 0) return

      api.userAddresses().then(data => {
        console.log('Load Customers')
        commit('saveCustomers', data.addresses)
      }).catch(error => {
        console.log(error)
      })
    },

    loadUser ({ commit }) {
      api.user().then(data => {
        console.log('Load User')
        commit('saveUser', data.user)
      }).catch(error => {
        console.log(error)
      })
    },

    loadCart ({ commit }) {
      api.cart().then(data => {
        console.log('Load Cart')
        commit('saveCart', data.cart)
      }).catch(error => {
        console.log(error)
      })
    },

    addCartItem ({ commit }, item) {
      if (!this.state.cart) return false
      api.addCartItem(this.state.cart.id, item).then(data => {
        console.log('Added item to cart')
        commit('saveCart', data.cart)
      }).catch(error => {
        console.log(error)
      })
    },

    updateCartItem ({ commit }, data) {
      if (!this.state.cart) return false
      api.updateCartItem(this.state.cart.id, data.id, data).then(data => {
        console.log('Update cart item')
        commit('saveCart', data.cart)
      }).catch(error => {
        console.log(error)
      })
    },

    removeCartItem ({ commit }, id) {
      if (!this.state.cart) return false
      api.removeCartItem(this.state.cart.id, id).then(data => {
        console.log('Removed cart item')
        commit('saveCart', data.cart)
      }).catch(error => {
        console.log(error)
      })
    },

    saveCart ({ commit }, cart) {
      api.saveCart(cart).then(data => {
        if (!data) return
        console.log('Save Cart', data.cart.id)
        commit('saveCart', data.cart)
      }).catch(error => {
        console.log(error)
      })
    }
  },

  strict: false
})



// WEBPACK FOOTER //
// ./src/store/index.js